export default "__VITE_ASSET__CvrVuufW__"